export default {"src":"/_next/static/media/sportsinfo.616260a7.svg","height":24,"width":116,"blurWidth":0,"blurHeight":0};